import styles from './style.module.css';

interface IRangeSlider {
  name: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  label?: string | JSX.Element;
  suffix?: string;
  errors?: string;
}

export function RangeSlider({
  name,
  min,
  max,
  step = 1,
  value,
  onChange,
  label,
  suffix,
  errors,
}: IRangeSlider) {
  const clamp = (next: number) => Math.min(max, Math.max(min, next));
  const percent = max === min ? 0 : ((value - min) / (max - min)) * 100;

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className={styles.wrapper}>
        <span className={styles.bound}>{min}</span>
        <input
          id={name}
          name={name}
          type="range"
          className={styles.slider}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(event) => onChange(clamp(Number(event.target.value)))}
          style={{
            background: `linear-gradient(to right, var(--primary) ${percent}%, var(--background-input) ${percent}%)`,
          }}
        />
        <div className={styles.stepper}>
          <button
            type="button"
            onClick={() => onChange(clamp(value - step))}
            disabled={value <= min}
            aria-label="Diminuir"
          >
            <i className="material-icons-outlined">chevron_left</i>
          </button>
          <span className={styles.current}>{value}</span>
          <button
            type="button"
            onClick={() => onChange(clamp(value + step))}
            disabled={value >= max}
            aria-label="Aumentar"
          >
            <i className="material-icons-outlined">chevron_right</i>
          </button>
        </div>
      </div>
      {suffix && <p className={styles.suffix}>{suffix}</p>}
      <span className={styles.error}>{errors}</span>
    </>
  );
}
